<template>
  <div class="app-container">
    <list ref="list"></list>
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/gd/super/list";

export default {
  name: "super",
  mixins: [curdMixins],
  components: {
    list,
  },
  data() {
    return {
      isMB: this.$store.state.isMB,
    };
  },
  methods: {},
};
</script>